import { signIn, SignInAuthorizationParams } from 'next-auth/react';
import { useCallback } from 'react';

import { getTrackingParams } from '../utils/facebookTracking';
import { useMetrics } from './useMetrics';

export type SignUpProps = {
  callbackUrl?: string;
  authParams?: SignInAuthorizationParams;
};

function useSignUp() {
  const metrics = useMetrics();

  const signup = useCallback(
    async (props?: SignUpProps) => {
      // Keep this in mixpanel due to funnel building
      metrics.logEvent('Signup', undefined, true);
      const currentUrl = window.location.href;
      const callbackURI = props?.callbackUrl ? props.callbackUrl : currentUrl || '/';

      // Get tracking parameters for conversion tracking
      const trackingParams = getTrackingParams();
      const fbclid = trackingParams.fbclid;
      const ttclid = trackingParams.ttclid;

      let callbackUrl = `/signup/success?callbackURI=${encodeURIComponent(callbackURI)}`;

      if (fbclid) {
        callbackUrl = `${callbackUrl}&fbclid=${fbclid}`;
      }

      if (ttclid) {
        callbackUrl = `${callbackUrl}&ttclid=${ttclid}`;
      }
      // Send user directly to Azure B2C
      await signIn(
        'azure-ad-b2c-signup',
        {
          callbackUrl: callbackUrl,
        },
        props?.authParams || { ui_locales: 'en', accountType: 'teacher' },
      );
    },
    [metrics],
  );

  return {
    signUp: signup,
  };
}

export default useSignUp;
